/** Keep in sync with backend casino pending bet expiry. */

export const PENDING_CASINO_BET_EXPIRE_MS = 90 * 1000;
export const PENDING_CASINO_BET_WARN_SECONDS = 30;

export const getPendingCasinoBetExpiresAt = (bet) => {
  if (!bet) return null;
  const base = bet.createdAt;
  if (!base) return null;
  const t = new Date(base).getTime();
  if (!Number.isFinite(t)) return null;
  return t + PENDING_CASINO_BET_EXPIRE_MS;
};

export const getPendingCasinoBetSecondsLeft = (bet, now = Date.now()) => {
  const expiresAt = getPendingCasinoBetExpiresAt(bet);
  if (expiresAt == null) return null;
  return Math.max(0, Math.ceil((expiresAt - now) / 1000));
};

export const isPendingCasinoBetPlayable = (bet, now = Date.now()) => {
  if (!bet || bet.status !== "Pending") return false;
  const secondsLeft = getPendingCasinoBetSecondsLeft(bet, now);
  return secondsLeft != null && secondsLeft > 0;
};

export const formatCasinoExpiryCountdown = (secondsLeft) => {
  const total = Math.max(0, Number(secondsLeft) || 0);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};
